import Link from "next/link";
import SectionHeader from "@/components/ui/section-header";
import { LifeBuoy } from "@/components/icons";
import { GREEN, HELP_URL } from "@/lib/constants";

const STEPS = [
  {
    title: "Datenvolumen-Plan wählen",
    body: "Ab $25/Monat für 25 GB.",
  },
  {
    title: "Tier 1 KYC oder Tier 2 KYB abschließen",
    body: "Der Zugriff wird freigeschaltet, sobald das Konto verifiziert ist.",
  },
  {
    title: "Access Point anlegen",
    body: "Zugangsdaten für das Residential-Netzwerk erzeugen.",
  },
  {
    title: "Targeting und Session-Modus einstellen",
    body: "Land, Stadt, ISP sowie rotierende oder sticky Sessions auswählen.",
  },
  {
    title: "Verbinden und prüfen",
    body: "Host, Port und Zugangsdaten im eigenen Tool hinterlegen.",
  },
];

export default function ResidentialSetupGuideDe() {
  return (
    <section
      className="py-section-sm border-border border-b"
      aria-labelledby="residential-setup-guide-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <SectionHeader
            eyebrow="Erste Schritte"
            id="residential-setup-guide-heading"
            heading="Proxidize Residential Proxies einrichten"
            body="Fünf Schritte von der Planwahl bis zur ersten Anfrage."
          />
        </div>

        <ol className="mt-8 grid list-none grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {STEPS.map((step, i) => (
            <li
              key={step.title}
              className="border-border bg-card flex flex-col gap-3 rounded-2xl border p-5"
            >
              <span
                className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold tabular-nums"
                style={{ background: `${GREEN}15`, color: "var(--brand-green)" }}
                aria-hidden="true"
              >
                {i + 1}
              </span>
              <span className="text-foreground text-sm font-semibold">{step.title}</span>
              <span className="text-muted-foreground text-sm leading-relaxed">{step.body}</span>
            </li>
          ))}
        </ol>

        <div className="border-border bg-muted/20 mt-8 flex flex-wrap items-center gap-3 rounded-xl border p-5">
          <span
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg"
            style={{ background: `${GREEN}15`, color: "var(--brand-green)" }}
            aria-hidden="true"
          >
            <LifeBuoy size={16} />
          </span>
          <p className="text-muted-foreground flex-1 text-sm leading-relaxed">
            Den vollständigen Verbindungscode benötigt? Siehe den Entwickler-Bereich weiter unten.
            Nicht weiter?{" "}
            <Link
              href={HELP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground decoration-foreground/30 hover:decoration-foreground underline underline-offset-4"
            >
              Help Center besuchen
            </Link>
            .
          </p>
        </div>
      </div>
    </section>
  );
}
